<template>
  <div
    class="container"
    style="background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%)"
  >
    <div>
      <van-nav-bar :title="$t('video.video')" class="header_b"> 
<template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
	</van-nav-bar>
    </div>
    <div class="video_box">
      <div class="nav_box_w">
        <div
          class="n_item"
          :class="navSel == kindex ? 'active' : ''"
          v-for="(item, kindex) in videolitem"
          :key="item.id"
          @click="
            onChange(item.id);
            navSel = kindex;
          "
        >
          {{ item.name }}
        </div>
      </div>
      <div class="nav_box_w">
        <div
          class="n_item"
          :class="navSel2 == kindex ? 'active' : ''"
          v-for="(item, kindex) in nav2list"
          :key="kindex"
          @click="navSel2 = kindex"
        >
          {{ item }}
        </div>
      </div>
      <div class="" style="height: 10px"></div>
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        :loading-text="$t('jzz')"
        :loosing-text="$t('sfjksx')"
      >
        <van-list
          v-model="loading"
          :loading-text="$t('jzz')"
          :finished="finished"
          @load="onLoad"
        >
          <div class="list-item">
            <div
              class="movie-list-item"
              v-for="(i, key) in data"
              :key="key"
              @click="toPlayVideo(i.id)"
            >
              <div class="imb_box">
                <img :src="i.vod_pic" class="van_img" />
                <div class="cc_zan">{{ $t("video.play") }} :{{ i.count }}</div>
              </div>
              <div class="c_yy">{{ i.vod_name }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div style="height: 55px"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      navSel: 0,
      navSel2: 0,
      list: [],
      nav2list: [this.$t("q55"), this.$t("q56"), this.$t("q57")],
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 0,
      id: 8,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 0;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          Toast(this.$t("sxwc"));
        }
      });
    },
    onChange(name) {
      this.id = name;
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad(true);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    getVideoList() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "get",
          data: { id: this.id, page: this.page },
          url: "video_list",
        })
          .then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
              this.data = this.data.concat(res.data.data);
              this.page++;
              resolve();
            } else {
              this.finished = true;
              resolve();
            }
          })
          .catch((error) => {
            console.error("Error fetching video list:", error);
            reject(error);
          });
      });
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        this.videolitem = res.data;
        // const obj = { id: 888, name: "最新,new,最新の,new" };
        // this.videolitem.unshift(obj);
        this.videolitem.forEach((item) => {
          const parts = item.name.split(",");
          lanng == "kr"
            ? (item.name = parts[0])
            : lanng == "en"
            ? (item.name = parts[1])
            : lanng == "ja"
            ? (item.name = parts[2])
            : (item.name = parts[3]);
        });
      });
    },
  },
  created() {
    this.getVideoClass();
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}
.header_b {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.video_box {
  padding-top: 100px;
  /deep/ .van-tabs__nav {
    background: linear-gradient(120deg, #212121, #313131);
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
  }
  .nav_box_w {
    display: flex;
    background: linear-gradient(120deg, #212121, #313131);
    padding: 20px;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    flex-wrap: wrap;
    .n_item {
      color: #fff;
      padding: 2px 16px;
      border-radius: 40px;
      margin-right: 20px;
      &.active {
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #623a13;
      }
    }
  }
  .c_yy {
    width: 100%;
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    color: #c7c7c7;
    font-size: 30px;
    padding: 12px 0 30px;
  }
  .movie-list-item {
    .imb_box {
      position: relative;
      .van_img {
        height: 300px;
        width: 100%;
        border-radius: 20px;
      }
      .cc_zan {
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 20px 0;
        color: #fff;
        bottom: 26px;
        right: 26px;
        font-size: 24px;
        padding: 2px 16px;
      }
    }
  }
}
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}

/deep/ .van-tabs__line {
  background-color: #c571cf;
}

/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;
}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;
}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/deep/ .van-pull-refresh__text {
  font-size: 32px;
  /* 设置字体大小 */
  color: #000;
}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.movie-list-item {
  width: calc(50% - 12px);
}

.cover_img {
  border-radius: 20px;
}

.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
}

.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.activeBg {
  color: rgb(197, 113, 207);
  font-weight: bold;
  background: url("/img/new.png") right top 5px / 30% no-repeat;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }

  .nav-bar {
    height: 50px;
  }
  /* 整体容器 */
  .video_box {
    width: 100%;
    padding-top: 0 !important;
  }

  /* 顶部不固定（PC必须） */
  .header_b {
    position: sticky !important;
    top: 0;
    z-index: 10;
  }

  /* 分类导航 */
  .nav_box_w {
    padding: 12px 20px !important;
  }

  .n_item {
    font-size: 13px;
    padding: 6px 14px !important;
    margin-right: 10px !important;
    transition: all 0.2s;
  }

  .n_item:hover {
    background: rgba(255, 255, 255, 0.08);
    cursor: pointer;
  }

  /* 视频列表（重点🔥） */
  .list-item {
    width: 100% !important;
    margin: 10px auto;
    gap: 16px; /* 间距优化 */
  }

  .movie-list-item {
    width: calc(25% - 12px); /* ⭐ PC四列 */
    transition: all 0.25s;
  }

  /* 卡片hover效果 */
  .movie-list-item:hover {
    transform: translateY(-6px);
  }

  /* 图片 */
  .van_img {
    height: 100px !important;
    border-radius: 10px !important;
  }

  /* 播放数 */
  .cc_zan {
    font-size: 12px !important;
    bottom: 10px !important;
    right: 10px !important;
    padding: 2px 8px !important;
  }

  /* 标题 */
  .c_yy {
    font-size: 13px !important;
    padding: 8px 0 12px !important;
  }

  /deep/ .van-pull-refresh__text {
    font-size: 20px;
    /* 设置字体大小 */
    color: #000;
  }
}
</style>
